"use client";
import { IconArrowDown as o } from "./assets/IconArrowDown.js";
import { IconArrowDownUp as r } from "./assets/IconArrowDownUp.js";
import { IconArrowLeft as n } from "./assets/IconArrowLeft.js";
import { IconArrowRight as m } from "./assets/IconArrowRight.js";
import { IconArrowUp as t } from "./assets/IconArrowUp.js";
import { IconArticle as i } from "./assets/IconArticle.js";
import { IconArtificialIntelligence as e } from "./assets/IconArtificialIntelligence.js";
import { IconAsset as c } from "./assets/IconAsset.js";
import { IconAttachment as p } from "./assets/IconAttachment.js";
import { IconBandCursor as l } from "./assets/IconBandCursor.js";
import { IconBands as f } from "./assets/IconBands.js";
import { IconBatteryEmpty as a } from "./assets/IconBatteryEmpty.js";
import { IconBatteryFull as I } from "./assets/IconBatteryFull.js";
import { IconBatteryLow as u } from "./assets/IconBatteryLow.js";
import { IconBearingFault as s } from "./assets/IconBearingFault.js";
import { IconBook as d } from "./assets/IconBook.js";
import { IconBulb as C } from "./assets/IconBulb.js";
import { IconBurger as h } from "./assets/IconBurger.js";
import { IconCPM as w } from "./assets/IconCPM.js";
import { IconCalculator as g } from "./assets/IconCalculator.js";
import { IconCalendar as F } from "./assets/IconCalendar.js";
import { IconCalendarBooked as D } from "./assets/IconCalendarBooked.js";
import { IconCalendarEmpty as b } from "./assets/IconCalendarEmpty.js";
import { IconCalendarNotBooked as y } from "./assets/IconCalendarNotBooked.js";
import { IconCalendarRecurring as k } from "./assets/IconCalendarRecurring.js";
import { IconCaretDown as v } from "./assets/IconCaretDown.js";
import { IconCaretUp as S } from "./assets/IconCaretUp.js";
import { IconCaretUpDown as O } from "./assets/IconCaretUpDown.js";
import { IconChat as U } from "./assets/IconChat.js";
import { IconCheck as A } from "./assets/IconCheck.js";
import { IconCheckCircle as R } from "./assets/IconCheckCircle.js";
import { IconCheckSmall as B } from "./assets/IconCheckSmall.js";
import { IconChevronDown as L } from "./assets/IconChevronDown.js";
import { IconChevronLeft as P } from "./assets/IconChevronLeft.js";
import { IconChevronRight as E } from "./assets/IconChevronRight.js";
import { IconChevronUp as H } from "./assets/IconChevronUp.js";
import { IconChevronUpDown as V } from "./assets/IconChevronUpDown.js";
import { IconClose as M } from "./assets/IconClose.js";
import { IconCloseAllFaults as N } from "./assets/IconCloseAllFaults.js";
import { IconCloseFault as z } from "./assets/IconCloseFault.js";
import { IconCloseSmall as x } from "./assets/IconCloseSmall.js";
import { IconColumnGraph as q } from "./assets/IconColumnGraph.js";
import { IconComment as G } from "./assets/IconComment.js";
import { IconConnection0 as T } from "./assets/IconConnection0.js";
import { IconConnection1 as W } from "./assets/IconConnection1.js";
import { IconConnection2 as X } from "./assets/IconConnection2.js";
import { IconConnection3 as Z } from "./assets/IconConnection3.js";
import { IconConnection4 as j } from "./assets/IconConnection4.js";
import { IconCopy as K } from "./assets/IconCopy.js";
import { IconDanger as J } from "./assets/IconDanger.js";
import { IconDefectFrequencies as Q } from "./assets/IconDefectFrequencies.js";
import { IconDefectFrequenciesAlternative as Y } from "./assets/IconDefectFrequenciesAlternative.js";
import { IconDoubleChevronLeft as _ } from "./assets/IconDoubleChevronLeft.js";
import { IconDoubleChevronRight as $ } from "./assets/IconDoubleChevronRight.js";
import { IconDownload as oo } from "./assets/IconDownload.js";
import { IconDraft as ro } from "./assets/IconDraft.js";
import { IconDraftFilled as no } from "./assets/IconDraftFilled.js";
import { IconDraftOutlined as mo } from "./assets/IconDraftOutlined.js";
import { IconDragNDrop as to } from "./assets/IconDragNDrop.js";
import { IconDrop as io } from "./assets/IconDrop.js";
import { IconDuplicate as eo } from "./assets/IconDuplicate.js";
import { IconEdit as co } from "./assets/IconEdit.js";
import { IconEmailFilled as po } from "./assets/IconEmailFilled.js";
import { IconEmailOutlined as lo } from "./assets/IconEmailOutlined.js";
import { IconExclamation as fo } from "./assets/IconExclamation.js";
import { IconEye as ao } from "./assets/IconEye.js";
import { IconEyeHidden as Io } from "./assets/IconEyeHidden.js";
import { IconEyeVisible as uo } from "./assets/IconEyeVisible.js";
import { IconFilter as so } from "./assets/IconFilter.js";
import { IconForbidden as Co } from "./assets/IconForbidden.js";
import { IconFullScreen as ho } from "./assets/IconFullScreen.js";
import { IconFullScreenExit as wo } from "./assets/IconFullScreenExit.js";
import { IconFunctionalLocation as go } from "./assets/IconFunctionalLocation.js";
import { IconHarmonicCursor as Fo } from "./assets/IconHarmonicCursor.js";
import { IconHeatmap as Do } from "./assets/IconHeatmap.js";
import { IconHierarchy as bo } from "./assets/IconHierarchy.js";
import { IconHistory as yo } from "./assets/IconHistory.js";
import { IconHistoryAlt as ko } from "./assets/IconHistoryAlt.js";
import { IconHourglassFramedFilled as vo } from "./assets/IconHourglassFramedFilled.js";
import { IconHourglassFramedOutlined as So } from "./assets/IconHourglassFramedOutlined.js";
import { IconHourglassOutlined as Oo } from "./assets/IconHourglassOutlined.js";
import { IconHz as Uo } from "./assets/IconHz.js";
import { IconIMX as Ao } from "./assets/IconIMX.js";
import { IconImage as Ro } from "./assets/IconImage.js";
import { IconInfoCircleFilled as Bo } from "./assets/IconInfoCircleFilled.js";
import { IconInfoCircleOutlined as Lo } from "./assets/IconInfoCircleOutlined.js";
import { IconIntegration as Po } from "./assets/IconIntegration.js";
import { IconKebab as Eo } from "./assets/IconKebab.js";
import { IconLink as Ho } from "./assets/IconLink.js";
import { IconListGroup as Vo } from "./assets/IconListGroup.js";
import { IconListItem as Mo } from "./assets/IconListItem.js";
import { IconLocationPin as No } from "./assets/IconLocationPin.js";
import { IconLock as zo } from "./assets/IconLock.js";
import { IconLogOut as xo } from "./assets/IconLogOut.js";
import { IconMeatballs as qo } from "./assets/IconMeatballs.js";
import { IconMicrophone as Go } from "./assets/IconMicrophone.js";
import { IconMinus as To } from "./assets/IconMinus.js";
import { IconMinusSmall as Wo } from "./assets/IconMinusSmall.js";
import { IconNoData as Xo } from "./assets/IconNoData.js";
import { IconO as Zo } from "./assets/IconO.js";
import { IconOpenInNew as jo } from "./assets/IconOpenInNew.js";
import { IconOverlayBaseline as Ko } from "./assets/IconOverlayBaseline.js";
import { IconPDF as Jo } from "./assets/IconPDF.js";
import { IconPaper as Qo } from "./assets/IconPaper.js";
import { IconPaste as Yo } from "./assets/IconPaste.js";
import { IconPause as _o } from "./assets/IconPause.js";
import { IconPieChart as $o } from "./assets/IconPieChart.js";
import { IconPin as or } from "./assets/IconPin.js";
import { IconPlay as rr } from "./assets/IconPlay.js";
import { IconPlus as nr } from "./assets/IconPlus.js";
import { IconPowerOff as mr } from "./assets/IconPowerOff.js";
import { IconPrinter as tr } from "./assets/IconPrinter.js";
import { IconProCollect as ir } from "./assets/IconProCollect.js";
import { IconRecAction as er } from "./assets/IconRecAction.js";
import { IconReceived as cr } from "./assets/IconReceived.js";
import { IconRefresh as pr } from "./assets/IconRefresh.js";
import { IconReorder as lr } from "./assets/IconReorder.js";
import { IconReplace as fr } from "./assets/IconReplace.js";
import { IconReply as ar } from "./assets/IconReply.js";
import { IconRewalkableRoute as Ir } from "./assets/IconRewalkableRoute.js";
import { IconRoutes as ur } from "./assets/IconRoutes.js";
import { IconSearch as sr } from "./assets/IconSearch.js";
import { IconSend as dr } from "./assets/IconSend.js";
import { IconSensorA as Cr } from "./assets/IconSensorA.js";
import { IconSensorB as hr } from "./assets/IconSensorB.js";
import { IconSettings as wr } from "./assets/IconSettings.js";
import { IconSidebandCursor as gr } from "./assets/IconSidebandCursor.js";
import { IconSingleCursor as Fr } from "./assets/IconSingleCursor.js";
import { IconSpectrum as Dr } from "./assets/IconSpectrum.js";
import { IconStarFilled as br } from "./assets/IconStarFilled.js";
import { IconStarOutlined as yr } from "./assets/IconStarOutlined.js";
import { IconStatusCircle as kr } from "./assets/IconStatusCircle.js";
import { IconStop as vr } from "./assets/IconStop.js";
import { IconStructuralVibration as Sr } from "./assets/IconStructuralVibration.js";
import { IconSync as Or } from "./assets/IconSync.js";
import { IconTimewave as Ur } from "./assets/IconTimewave.js";
import { IconTrash as Ar } from "./assets/IconTrash.js";
import { IconTrend as Rr } from "./assets/IconTrend.js";
import { IconTrendingUp as Br } from "./assets/IconTrendingUp.js";
import { IconUndo as Lr } from "./assets/IconUndo.js";
import { IconUnknownCircle as Pr } from "./assets/IconUnknownCircle.js";
import { IconUnknownDiamond as Er } from "./assets/IconUnknownDiamond.js";
import { IconUnlink as Hr } from "./assets/IconUnlink.js";
import { IconUnlock as Vr } from "./assets/IconUnlock.js";
import { IconUnscheduledAction as Mr } from "./assets/IconUnscheduledAction.js";
import { IconUpload as Nr } from "./assets/IconUpload.js";
import { IconUser as zr } from "./assets/IconUser.js";
import { IconViewFull as xr } from "./assets/IconViewFull.js";
import { IconViewHorizontal as qr } from "./assets/IconViewHorizontal.js";
import { IconViewVertical as Gr } from "./assets/IconViewVertical.js";
import { IconWarning as Tr } from "./assets/IconWarning.js";
import { IconWarningCircle as Wr } from "./assets/IconWarningCircle.js";
import { IconWarningDiamond as Xr } from "./assets/IconWarningDiamond.js";
import { IconZoomIn as Zr } from "./assets/IconZoomIn.js";
import { IconZoomOut as jr } from "./assets/IconZoomOut.js";
const Gt = Object.freeze({
  arrowDown: o,
  arrowDownUp: r,
  arrowLeft: n,
  arrowRight: m,
  arrowUp: t,
  article: i,
  artificialIntelligence: e,
  asset: c,
  attachment: p,
  bandCursor: l,
  bands: f,
  batteryEmpty: a,
  batteryFull: I,
  batteryLow: u,
  bearingFault: s,
  book: d,
  bulb: C,
  burger: h,
  cPM: w,
  calculator: g,
  calendar: F,
  calendarBooked: D,
  calendarEmpty: b,
  calendarNotBooked: y,
  calendarRecurring: k,
  caretDown: v,
  caretUp: S,
  caretUpDown: O,
  chat: U,
  check: A,
  checkCircle: R,
  checkSmall: B,
  chevronDown: L,
  chevronLeft: P,
  chevronRight: E,
  chevronUp: H,
  chevronUpDown: V,
  close: M,
  closeAllFaults: N,
  closeFault: z,
  closeSmall: x,
  columnGraph: q,
  comment: G,
  connection0: T,
  connection1: W,
  connection2: X,
  connection3: Z,
  connection4: j,
  copy: K,
  danger: J,
  defectFrequencies: Q,
  defectFrequenciesAlternative: Y,
  doubleChevronLeft: _,
  doubleChevronRight: $,
  download: oo,
  draft: ro,
  draftFilled: no,
  draftOutlined: mo,
  dragNDrop: to,
  drop: io,
  duplicate: eo,
  edit: co,
  emailFilled: po,
  emailOutlined: lo,
  exclamation: fo,
  eye: ao,
  eyeHidden: Io,
  eyeVisible: uo,
  filter: so,
  forbidden: Co,
  fullScreen: ho,
  fullScreenExit: wo,
  functionalLocation: go,
  harmonicCursor: Fo,
  heatmap: Do,
  hierarchy: bo,
  history: yo,
  historyAlt: ko,
  hourglassFramedFilled: vo,
  hourglassFramedOutlined: So,
  hourglassOutlined: Oo,
  hz: Uo,
  iMX: Ao,
  image: Ro,
  infoCircleFilled: Bo,
  infoCircleOutlined: Lo,
  integration: Po,
  kebab: Eo,
  link: Ho,
  listGroup: Vo,
  listItem: Mo,
  locationPin: No,
  lock: zo,
  logOut: xo,
  meatballs: qo,
  microphone: Go,
  minus: To,
  minusSmall: Wo,
  noData: Xo,
  o: Zo,
  openInNew: jo,
  overlayBaseline: Ko,
  pDF: Jo,
  paper: Qo,
  paste: Yo,
  pause: _o,
  pieChart: $o,
  pin: or,
  play: rr,
  plus: nr,
  powerOff: mr,
  printer: tr,
  proCollect: ir,
  recAction: er,
  received: cr,
  refresh: pr,
  reorder: lr,
  replace: fr,
  reply: ar,
  rewalkableRoute: Ir,
  routes: ur,
  search: sr,
  send: dr,
  sensorA: Cr,
  sensorB: hr,
  settings: wr,
  sidebandCursor: gr,
  singleCursor: Fr,
  spectrum: Dr,
  starFilled: br,
  starOutlined: yr,
  statusCircle: kr,
  stop: vr,
  structuralVibration: Sr,
  sync: Or,
  timewave: Ur,
  trash: Ar,
  trend: Rr,
  trendingUp: Br,
  undo: Lr,
  unknownCircle: Pr,
  unknownDiamond: Er,
  unlink: Hr,
  unlock: Vr,
  unscheduledAction: Mr,
  upload: Nr,
  user: zr,
  viewFull: xr,
  viewHorizontal: qr,
  viewVertical: Gr,
  warning: Tr,
  warningCircle: Wr,
  warningDiamond: Xr,
  zoomIn: Zr,
  zoomOut: jr
});
export {
  Gt as ICONS
};
